module.exports = __webpack_public_path__ + "img/98-1.78ab102c.png";